(function() {
  // Quantity controls
  window.hydeQty = function(d) {
    var q = document.getElementById('hyde-qty');
    var v = parseInt(q.value) || 1;
    q.value = Math.max(1, v + d);
    updateTotal();
  };
  
  var dataEl = document.getElementById('hyde-pdp-data');
  var data = {};
  if (dataEl) {
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      data = {};
    }
  }

  var baseCents = data.msrpCents || 0;        // selling price of the active variant
  var compareCents = data.compareCents || 0;  // manufacturer compare-at, 0 when none
  var currencyCode = data.currencyCode || 'USD';
  var unitPriceEl = document.getElementById('hyde-unit-price');
  var msrpEl = document.getElementById('hyde-msrp-price');
  var saveEl = document.getElementById('hyde-save-pill');
  var totalEl = document.getElementById('hyde-total');
  var stickyPriceEl = document.getElementById('hyde-sticky-price');
  var tierTableEl = document.getElementById('hyde-tier-table');
  var showStandard = data.showStandard !== undefined ? data.showStandard : true;
  var variantSelect = document.getElementById('hyde-variant-select');
  var variantIdInput = document.getElementById('hyde-variant-id');
  var addToCartBtn = document.querySelector('.hyde-pdp__cart-btn');
  var stockDotEl = document.querySelector('.hyde-pdp__stock-dot');
  var stockTextEl = document.querySelector('.hyde-pdp__stock-text');
  var shipsEl = document.querySelector('.hyde-pdp__ships');
  var variants = Array.isArray(data.variants) ? data.variants : [];
  var activeVariantId = data.activeVariantId;

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', {style: 'currency', currency: currencyCode});
  }

  function normalizeTiers(raw) {
    if (!Array.isArray(raw)) return [];
    return raw.map(function(t) {
      var min = parseInt(t.min, 10);
      if (isNaN(min)) min = 1;
      var discount = parseFloat(t.discount_pct || t.discount || 0);
      if (isNaN(discount)) discount = 0;
      var priceCents = null;
      if (t.price_cents != null) {
        priceCents = parseInt(t.price_cents, 10);
      } else if (t.price != null) {
        var p = parseFloat(t.price);
        if (!isNaN(p)) priceCents = Math.round(p * 100);
      }
      return {
        min: min,
        discount_pct: Math.max(0, Math.min(100, discount)),
        price_cents: priceCents,
        label: (t.label || t.highlight || '')
      };
    }).sort(function(a, b) { return a.min - b.min; });
  }

  function getTierData() {
    var el = document.getElementById('hyde-tier-data');
    if (!el) return [];
    try {
      return normalizeTiers(JSON.parse(el.textContent));
    } catch (e) {
      return [];
    }
  }

  var tiers = getTierData();

  function getActiveTier(qty) {
    if (!tiers.length) return null;
    var active = tiers[0];
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i].min) active = tiers[i];
    }
    return active;
  }

  function getUnitPriceCents(tier) {
    if (!tier) return baseCents;
    if (tier.price_cents != null && !isNaN(tier.price_cents)) return tier.price_cents;
    // Match the checkout discount function exactly: the per-unit discount is
    // floored to the cent (verified against live carts 2026-07-14), so the
    // displayed price never undercuts what checkout charges.
    var discountCents = Math.floor(baseCents * tier.discount_pct / 100);
    return Math.max(0, baseCents - discountCents);
  }

  function renderTierTable(activeTier) {
    if (!tierTableEl) return;
    if (!tiers.length) {
      tierTableEl.innerHTML = '<div class="hyde-pdp__tier-note">Volume discounts available at checkout.</div>';
      return;
    }
    var html = '';
    for (var i = 0; i < tiers.length; i++) {
      var tier = tiers[i];
      if (!showStandard && tier.discount_pct <= 0) {
        continue;
      }
      var nextMin = (i + 1 < tiers.length) ? tiers[i + 1].min : null;
      var qtyLabel;
      if (!nextMin) {
        qtyLabel = tier.min + '+';
      } else if (nextMin - 1 === tier.min) {
        qtyLabel = String(tier.min);
      } else {
        qtyLabel = tier.min + '–' + (nextMin - 1);
      }
      var unitCents = getUnitPriceCents(tier);
      var isActive = activeTier && tier.min === activeTier.min;
      var saveLabel = tier.discount_pct > 0 ? ('SAVE ' + tier.discount_pct + '%') : 'Standard price';
      var badge = tier.label ? ('<span class="hyde-pdp__tier-badge">' + tier.label + '</span>') : '';
      html += '<button type="button" class="hyde-pdp__tier-row' + (isActive ? ' is-active' : '') + '"'
        + ' data-min="' + tier.min + '" aria-pressed="' + (isActive ? 'true' : 'false') + '">'
        + '<span class="hyde-pdp__tier-qty">Buy ' + qtyLabel + '</span>'
        + '<span class="hyde-pdp__tier-price">' + formatMoney(unitCents) + ' / ea</span>'
        + '<span class="hyde-pdp__tier-save">' + saveLabel + '</span>'
        + badge
        + '</button>';
    }
    tierTableEl.innerHTML = html;
    tierTableEl.querySelectorAll('.hyde-pdp__tier-row').forEach(function(row) {
      row.addEventListener('click', function() {
        var min = parseInt(row.dataset.min, 10);
        if (isNaN(min)) return;
        var qtyInput = document.getElementById('hyde-qty');
        if (!qtyInput) return;
        qtyInput.value = Math.max(1, min);
        updateTotal();
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function updateTotal() {
    var qtyInput = document.getElementById('hyde-qty');
    if (!qtyInput) return;
    var qty = parseInt(qtyInput.value) || 1;
    var activeTier = getActiveTier(qty);
    var unitCents = getUnitPriceCents(activeTier);
    var total = formatMoney(unitCents * qty);
    if (unitPriceEl) unitPriceEl.textContent = formatMoney(unitCents);
    if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(unitCents);
    if (totalEl) totalEl.textContent = total;
    if (msrpEl) {
      // Struck price: the standard unit price when a tier discount is active,
      // else a real compare-at when it is materially higher (>= $1) than price.
      if (activeTier && activeTier.discount_pct > 0) {
        msrpEl.textContent = formatMoney(baseCents);
        msrpEl.hidden = false;
      } else if (compareCents >= baseCents + 100) {
        msrpEl.textContent = formatMoney(compareCents);
        msrpEl.hidden = false;
      } else {
        msrpEl.hidden = true;
      }
    }
    if (saveEl) {
      if (activeTier && activeTier.discount_pct > 0) {
        saveEl.hidden = false;
        saveEl.textContent = 'Save ' + activeTier.discount_pct + '%';
      } else {
        saveEl.hidden = true;
        saveEl.textContent = '';
      }
    }
    renderTierTable(activeTier);
  }

  function updateStock(variant) {
    if (!stockDotEl || !stockTextEl || !variant) return;
    stockDotEl.classList.remove('hyde-pdp__stock-dot--low', 'hyde-pdp__stock-dot--out');
    stockTextEl.classList.remove('hyde-pdp__stock-text--low', 'hyde-pdp__stock-text--out');
    if (variant.available) {
      if (variant.inventory_quantity > 10) {
        stockTextEl.textContent = 'In Stock';
      } else if (variant.inventory_quantity > 0) {
        stockDotEl.classList.add('hyde-pdp__stock-dot--low');
        stockTextEl.classList.add('hyde-pdp__stock-text--low');
        stockTextEl.textContent = 'Only ' + variant.inventory_quantity + ' left';
      } else {
        stockTextEl.textContent = 'In Stock';
      }
      if (shipsEl) shipsEl.style.display = '';
    } else {
      stockDotEl.classList.add('hyde-pdp__stock-dot--out');
      stockTextEl.classList.add('hyde-pdp__stock-text--out');
      stockTextEl.textContent = 'Out of Stock';
      if (shipsEl) shipsEl.style.display = 'none';
    }
  }

  function applyVariant(variant) {
    if (!variant) return;
    if (variantIdInput) variantIdInput.value = variant.id;
    baseCents = variant.price;
    compareCents = variant.compare_at || 0;
    if (addToCartBtn) addToCartBtn.disabled = !variant.available;
    updateStock(variant);
    updateTotal();
  }
  
  var qtyInput = document.getElementById('hyde-qty');
  if (qtyInput) {
    qtyInput.addEventListener('change', updateTotal);
    qtyInput.addEventListener('input', updateTotal);
  }
  if (variantSelect && variants && variants.length) {
    variantSelect.addEventListener('change', function() {
      var id = parseInt(variantSelect.value, 10);
      var variant = variants.find(function(v) { return v.id === id; });
      applyVariant(variant);
    });
    applyVariant(variants.find(function(v) { return v.id === activeVariantId; }) || variants[0]);
  }
  updateTotal();
  
  // Gallery thumbnails — with srcset support
  var thumbs = document.querySelectorAll('.hyde-pdp__gallery-thumb');
  var mainImg = document.getElementById('hyde-main-img');
  var counter = document.querySelector('.hyde-pdp__gallery-counter');
  var total = thumbs.length;

  thumbs.forEach(function(t) {
    t.addEventListener('click', function() {
      thumbs.forEach(function(x) {
        x.classList.remove('active');
        x.setAttribute('aria-selected', 'false');
      });
      t.classList.add('active');
      t.setAttribute('aria-selected', 'true');
      mainImg.src = t.dataset.img;
      // Update srcset for responsive images
      if (t.dataset.srcset) {
        mainImg.srcset = t.dataset.srcset;
      }
      if (counter) counter.textContent = t.dataset.idx + ' / ' + total;
    });
  });
  
  function setActivePanel(panelName) {
    if (!panelName) return;
    document.querySelectorAll('.hyde-pdp__tab-btn').forEach(function(x) {
      x.setAttribute('aria-selected', x.dataset.tab === panelName ? 'true' : 'false');
    });
    document.querySelectorAll('.hyde-pdp__tab-panel').forEach(function(p) {
      p.dataset.active = p.dataset.panel === panelName ? 'true' : 'false';
    });
    document.querySelectorAll('.hyde-pdp__tab-section').forEach(function(section) {
      section.dataset.open = section.dataset.panel === panelName ? 'true' : 'false';
    });
    document.querySelectorAll('.hyde-pdp__accordion-btn').forEach(function(btn) {
      btn.setAttribute('aria-expanded', btn.dataset.panel === panelName ? 'true' : 'false');
    });
  }

  // Desktop tabs
  document.querySelectorAll('.hyde-pdp__tab-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      setActivePanel(btn.dataset.tab);
    });
  });

  // Mobile accordion
  document.querySelectorAll('.hyde-pdp__accordion-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var section = btn.closest('.hyde-pdp__tab-section');
      if (!section) return;
      var isOpen = section.dataset.open === 'true';
      if (isOpen) {
        section.dataset.open = 'false';
        btn.setAttribute('aria-expanded', 'false');
        var panel = section.querySelector('.hyde-pdp__tab-panel');
        if (panel) panel.dataset.active = 'false';
        return;
      }
      setActivePanel(btn.dataset.panel);
    });
  });

  var initialTab = null;
  var selectedTab = document.querySelector('.hyde-pdp__tab-btn[aria-selected=\"true\"]');
  if (selectedTab) initialTab = selectedTab.dataset.tab;
  if (!initialTab) initialTab = 'details';
  setActivePanel(initialTab);
  
  // Sticky bar visibility
  var stickyBar = document.getElementById('hyde-sticky-bar');
  var cartBtn = document.querySelector('.hyde-pdp__cart-btn');

  if (stickyBar && cartBtn) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('visible');
        } else {
          stickyBar.classList.add('visible');
        }
      });
    }, { threshold: 0, rootMargin: '-100px 0px 0px 0px' });

    observer.observe(cartBtn);
  }

  // Quantity +/- buttons
  document.querySelectorAll('.hyde-pdp__qty-btn[data-qty-delta]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var delta = parseInt(btn.dataset.qtyDelta, 10);
      if (!isNaN(delta)) window.hydeQty(delta);
    });
  });

  // AJAX add-to-cart: keeps the buyer on the PDP, updates the header count,
  // and shows inline next actions. Falls back to native submit on any error.
  var productForm = document.getElementById('hyde-product-form');

  function setHeaderCount(count) {
    var badge = document.querySelector('.hyde-header-action__count');
    if (badge) {
      badge.textContent = count;
    } else {
      var cartAction = document.querySelector('a[href="/cart"].hyde-header-action, .hyde-header-action--cart');
      if (cartAction) {
        badge = document.createElement('span');
        badge.className = 'hyde-header-action__count';
        badge.textContent = count;
        cartAction.appendChild(badge);
      }
    }
  }

  var cartBtnLabel = cartBtn ? cartBtn.textContent : '';

  function showAddedState() {
    if (cartBtn) {
      cartBtn.textContent = '✓ Added to Cart';
      cartBtn.disabled = true;
    }
    var actions = document.getElementById('hyde-added-actions');
    if (!actions) {
      actions = document.createElement('div');
      actions.id = 'hyde-added-actions';
      actions.className = 'hyde-pdp__added-actions';
      actions.innerHTML = '<a class="hyde-pdp__added-link" href="/cart">View Cart</a>'
        + '<a class="hyde-pdp__added-link hyde-pdp__added-link--checkout" href="/checkout">Checkout</a>';
      productForm.appendChild(actions);
    }
    actions.style.display = '';
    setTimeout(function() {
      if (cartBtn) {
        cartBtn.textContent = cartBtnLabel;
        cartBtn.disabled = false;
      }
    }, 2500);
  }

  var ajaxInFlight = false;
  if (productForm && window.fetch) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      if (ajaxInFlight) return;
      ajaxInFlight = true;
      var added = false;
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(productForm),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function(res) {
        if (!res.ok) throw new Error('add failed: ' + res.status);
        // The add reached the server successfully: from here on any failure
        // must degrade gracefully, never re-submit (double-add).
        added = true;
        return res.json();
      }).then(function() {
        ajaxInFlight = false;
        showAddedState();
        return fetch('/cart.js')
          .then(function(r) {
            if (!r.ok) throw new Error('readback failed');
            return r.json();
          })
          .then(function(cart) { setHeaderCount(cart.item_count); })
          .catch(function() { /* badge update skipped; add already succeeded */ });
      }).catch(function() {
        ajaxInFlight = false;
        if (added) return;
        // Native fallback only when the add itself failed
        productForm.submit();
      });
    });
  }

  // Sticky-bar Add to Cart submits the real product form
  var stickyBtn = document.querySelector('.hyde-pdp__sticky-btn');
  if (stickyBtn && productForm) {
    stickyBtn.addEventListener('click', function() {
      if (typeof productForm.requestSubmit === 'function') {
        productForm.requestSubmit();
      } else {
        productForm.submit();
      }
    });
  }
})();
